import {gsap} from "gsap";
import {Power4} from "gsap/gsap-core";

gsap.registerPlugin(Power4)

const MenuDropdown = {
    hideSelected: true,

    init(menu) {

        menu.find('.dropdown').each((i, el) => {
            $(el).wrap('<div class="dropdown-canvas">');
            const li = $(el).closest('li');
            this.bind(li);
        })
    },

    bind(li) {

        li.unbind('mouseenter').mouseenter((evt) => {
            const li = $(evt.currentTarget);
            const selected = li.siblings('.selected');
            // if (li.is('.selected') || window.innerWidth < 1000) return;

            this.show(li);

            if (!this.hideSelected) return;

            if (selected && selected.length) {
                this.hide(selected);
            }
        })

        li.unbind('mouseleave').mouseleave((evt) => {
            const el = $(evt.currentTarget);
            const selected = el.siblings('.selected');
            // if (el.is('.selected') || window.innerWidth < 1000) return;

            this.hide(li);

            if (!this.hideSelected) return;

            setTimeout(() => {
                el.removeClass('hover');

                if (selected && selected.length) {
                    this.show(selected);
                }
            }, 400)
        })
    },

    show(li) {
        const dropdownCanvas = li.find('> .dropdown-canvas');
        const dropdown = dropdownCanvas.find('ul.dropdown');

        gsap.set(dropdownCanvas, {display: 'block'})
        gsap.fromTo(dropdown, {
                y: '-100%', display: 'none'
            }, {
                y: '0%', display: 'flex', duration: 0.5, overwrite: true
            }
        );

        li.addClass('hover');
    },

    hide(li) {
        const dropdownCanvas = li.find('> .dropdown-canvas');
        const dropdown = dropdownCanvas.find('ul.dropdown');


        gsap.fromTo(dropdown, {
                y: '0%', display: 'none'
            }, {
                y: '-100%', display: 'flex', duration: 0.5, overwrite: true,
                onComplete: () => {
                    li.addClass('hover');
                    gsap.set(dropdownCanvas, {display: 'none'})
                }
            }
        );

        li.removeClass('hover');
    },

}

export default MenuDropdown;